import { DataLayer } from "@grandvisionhq/analytics";
import { getSharedProductDetailEventTrackingAttributes, getVariantSpecification } from "./get-shared-product-detail-event-tracking-attributes.js";
const getJoinedValues = (values) => values?.join(", ").toLowerCase() || "";
const getAccessoriesEventAttributes = (sharedAttributes, masterSku, activeVariant) => ({
  ...sharedAttributes,
  category: DataLayer.DataLayerTypes.Category.Accessories,
  brand: getVariantSpecification(["brand"], activeVariant),
  variant: getVariantSpecification(["accessoryTypeUnlocalized", "accessoryType"], activeVariant),
  dimension16: getVariantSpecification(
    ["genderUnlocalized", "gender"],
    activeVariant
  ).toLowerCase(),
  dimension146: getVariantSpecification(["materialUnlocalized", "material"], activeVariant),
  dimension147: getVariantSpecification(
    ["accessoryColorUnlocalized", "accessoryColor"],
    activeVariant
  ),
  dimension140: masterSku
});
const getSunglassesEventAttributes = (sharedAttributes, masterSku, activeVariant) => {
  return {
    ...sharedAttributes,
    category: DataLayer.DataLayerTypes.Category.Sunglasses,
    brand: getVariantSpecification(["brand"], activeVariant),
    variant: getVariantSpecification(["frameShapeUnlocalized", "frameShape"], activeVariant),
    dimension16: getVariantSpecification(
      ["genderUnlocalized", "gender"],
      activeVariant
    ).toLowerCase(),
    dimension140: masterSku,
    dimension146: getVariantSpecification(
      ["frameMaterialUnlocalized", "frameMaterial"],
      activeVariant
    ),
    dimension147: getVariantSpecification(["frameColorUnlocalized", "frameColor"], activeVariant),
    dimension191: getVariantSpecification(["frameTypeUnlocalized", "frameType"], activeVariant),
    dimension192: getJoinedValues(activeVariant.faceShapes)
  };
};
const getFramesEventAttributes = (sharedAttributes, masterSku, activeVariant) => {
  return {
    ...sharedAttributes,
    category: DataLayer.DataLayerTypes.Category.Optical,
    brand: getVariantSpecification(["brand"], activeVariant),
    variant: getVariantSpecification(["frameShapeUnlocalized", "frameShape"], activeVariant),
    dimension16: getVariantSpecification(
      ["genderUnlocalized", "gender"],
      activeVariant
    ).toLowerCase(),
    dimension140: masterSku,
    dimension146: getVariantSpecification(["frameMaterialUnlocalized", "frameMaterial"], activeVariant) ?? "",
    dimension147: getVariantSpecification(["frameColorUnlocalized", "frameColor"], activeVariant) ?? "",
    dimension191: getVariantSpecification(["frameTypeUnlocalized", "frameType"], activeVariant),
    dimension192: getJoinedValues(activeVariant.faceShapes)
  };
};
const getContactLensesEventAttributes = (sharedAttributes, masterSku, activeVariant) => {
  return {
    ...sharedAttributes,
    brand: getVariantSpecification(["brand"], activeVariant),
    category: DataLayer.DataLayerTypes.Category.ContactLenses,
    variant: getVariantSpecification(["lensTypeUnlocalized", "lensType"], activeVariant),
    dimension140: masterSku,
    dimension148: getVariantSpecification(
      ["replacementFrequencyUnlocalized", "replacementFrequency"],
      activeVariant
    ),
    dimension146: getVariantSpecification(["materialUnlocalized", "material"], activeVariant)
  };
};
const getReadyReadersEventAttributes = (sharedAttributes, masterSku, activeVariant) => {
  return {
    ...sharedAttributes,
    category: DataLayer.DataLayerTypes.Category.ReadyReaders,
    brand: getVariantSpecification(["brand"], activeVariant),
    variant: getVariantSpecification(["frameShapeUnlocalized", "frameShape"], activeVariant),
    dimension16: getVariantSpecification(["genderUnlocalized", "gender"], activeVariant),
    dimension140: masterSku,
    dimension146: getVariantSpecification(["frameMaterialUnlocalized", "frameMaterial"], activeVariant) ?? "",
    dimension147: getVariantSpecification(["frameColorUnlocalized", "frameColor"], activeVariant) ?? "",
    dimension191: getVariantSpecification(["frameTypeUnlocalized", "frameType"], activeVariant),
    dimension192: ""
    // Ready readers do not contain face shape attribute
  };
};
const getSolutionsEventAttributes = (sharedAttributes, masterSku, activeVariant) => {
  return {
    ...sharedAttributes,
    category: DataLayer.DataLayerTypes.Category.Solutions,
    brand: getVariantSpecification(["brand"], activeVariant),
    variant: activeVariant.facets.packageOption ?? "",
    dimension140: masterSku,
    dimension146: activeVariant.contactLensCareType ?? ""
  };
};
const getProductDetailEventTrackingAttributes = (props) => {
  const { masterSku, activeVariant } = props;
  const sharedAttributes = getSharedProductDetailEventTrackingAttributes(props);
  switch (activeVariant.variantType) {
    case "sunglasses":
      return getSunglassesEventAttributes(sharedAttributes, masterSku, activeVariant);
    case "accessories":
      return getAccessoriesEventAttributes(sharedAttributes, masterSku, activeVariant);
    case "frames":
      return getFramesEventAttributes(sharedAttributes, masterSku, activeVariant);
    case "contact-lens":
      return getContactLensesEventAttributes(sharedAttributes, masterSku, activeVariant);
    case "ready-reader":
      return getReadyReadersEventAttributes(sharedAttributes, masterSku, activeVariant);
    case "solutions":
      return getSolutionsEventAttributes(sharedAttributes, masterSku, activeVariant);
    default:
      return void 0;
  }
};
export {
  getProductDetailEventTrackingAttributes
};
//# sourceMappingURL=get-product-detail-event-tracking-attributes.js.map
